<template>
    <el-drawer
        title="获奖用户导入"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-upload 
                drag 
                action
                :http-request="uploadFile"
                :auto-upload="false"
                ref="upload"
                accept=".xls, .xlsx"
                :show-file-list="true"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :on-change="onChange"
                :on-remove="onRemove"
                :disabled="uploadLoading">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                <div class="el-upload__tip" slot="tip">
                    <span class="el-icon-warning"></span>只能上传xls、xlsx文件，最多不超过10W行
                </div>
            </el-upload>
            
            <div class="color-info">
                <!-- 导入文件示例如下: -->
                <el-button 
                    v-if="$utils.have('/shareActivity/joinedUser/downloadAwardTemp')" 
                    type="text" 
                    icon="el-icon-download" 
                    @click="download"
                    :loading="downLoading">
                    点击下载模板
                </el-button>
            </div>
            <!-- <el-table
                :data="dataList"
                border
                style="width: 100%"
                size="small"
            >
                <el-table-column prop="userId" label="用户ID" min-width="80"></el-table-column>
                <el-table-column prop="type" label="奖品类型" min-width="80"></el-table-column>
                <el-table-column prop="id" label="奖品ID(实物奖品填SKUID)" min-width="190"></el-table-column>
                <el-table-column prop="num" label="数量" min-width="60"></el-table-column>
                <el-table-column prop="place" label="领奖地" min-width="100"></el-table-column>
            </el-table> -->
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
                >导入</el-button
            >
        </div>
        <ErrorMsgDrawer ref="errorMsgDrawer"></ErrorMsgDrawer>     
    </el-drawer>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    components:{ErrorMsgDrawer},
    data() {
        return {
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,
            dataList:[{
                userId:'1123',
                type:'实物奖品',
                id:'110695',
                num:'1',
                place:'小酒馆芳沁店'
            },{
                userId:'1124',
                type:'优惠券',
                id:'110696',
                num:'2',
                place:''
            }],
            canSubmit:true,
            fileList:[],
        };
    },
    methods: {
        show(id) {
            this.lotteryActivityId = id
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        onSubmit() {
            this.$refs.upload.submit();
        },
        async uploadFile(req){

            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);
            
            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }    

            this.$request({
                url:'/lottery/activity/white/import',
                method: 'post',
                params:{lotteryActivityId:this.lotteryActivityId,filePath:filePath},
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result && result.importErrorDetailVOList && result.importErrorDetailVOList.length > 0){
                            this.$refs.errorMsgDrawer.show(result);
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });

        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess(){
            this.$emit('update');
            this.close();
        },
        //下载模板
        async download(){
            this.downLoading = true;
            let filePath;
            const res = await this.$request({
                url:'/lottery/activity/white/template',
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 && url){
                filePath = url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'幸运抽奖白名单模板.'+this.$utils.getFileType(filePath));
            this.downLoading = false;

        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>